import { STYLE_ID } from './useEditorBaseFont.constants'

export function getTextCss(font) {
  return `
    body {
      font-family: ${font.name};
      font-size: ${font.size}px;
    }
  `
}

export function applyBaseFont(editorRef, defaultFont) {
  const editor = editorRef?.getDoc?.()

  if (!editor) {
    return
  }

  const css = getTextCss(defaultFont)
  let styleEl = editor.getElementById(STYLE_ID)

  //  Add/update inside iframe head
  if (!styleEl) {
    styleEl = editorRef.dom.create('style', {
      id: STYLE_ID,
      type: 'text/css',
    })
    styleEl.appendChild(editor.createTextNode(css))
    editorRef.dom.add(editor.head, styleEl)
  } else {
    styleEl.textContent = css
  }

  const body = editorRef.getBody?.()

  if (body) {
    //Helps editor toolbar detect the current font/size after SetContent/LoadContent
    body.style.fontFamily = `${defaultFont.name}, ${defaultFont.family}`
    body.style.fontSize = `${defaultFont.size}px`
  }

  // Ask TinyMCE to recompute toolbar state
  editorRef.nodeChanged()
}
